import  React from "react";
import { Box, Container, Grid, Flex, Text, GridItem, Image } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { ReactComponent as IOSBadge } from '../Assets/SVGs/IOSbadge.svg';
import { ReactComponent as GBadge } from '../Assets/SVGs/GBadge.svg';



export default function Footer(){
    return(
        <div>
           
                <Box w={"100vw"} borderTop="1px #cecece solid" >
                    <Container maxW={["92vw", "84vw", "84vw"]}  pt={"95px"} >
                        <Grid templateColumns={[ "repeat(1, 1fr)", "repeat(1, 1fr)","repeat(1, 1fr)", "repeat(6, 1fr)"]} gap={6} pb={["80px", "160px", "160px"]}>
                            <Box>
                               
                                <Image src="https://do1pg20gb8r9m.cloudfront.net/logoShirt.png"  h={["auto", "auto", "auto", "35px"]} w={["50%", "50%", "50%", "auto"]}  />
                                <Grid templateColumns={[ "repeat(1, 1fr)"]} mt="30px">
                                    <Text mb="15px" fontWeight={900}>Coming Soon</Text>
                                    <Box>
                                        <IOSBadge/>
                                    </Box>
                                    <Box mt="10px">
                                        <GBadge style={{ width: "119.65px", height: "40px" }}/>
                                    </Box>
                               
                                </Grid>
                            </Box>
                            
                            <Box/>
                            <Box/>
                            <GridItem colSpan={[2, 2, 2, 1]}>
                                <Box  mt={8}> 
                                    <Text fontSize="xl" color={"#4f8df7"} >
                                        Legal
                                    </Text>
                                    <Text fontSize="sm"  mt={6}>
                                        <Link to="/privacy">              
                                            Privacy Policy
                                        </Link>  
                                    </Text>
                                    <Text fontSize="sm"  mt={3}>
                                        <Link to="/terms"> 
                                            Terms & Conditions
                                        </Link>  
                                    </Text>
                                    <Text fontSize="sm"  mt={3}>
                                        <Link to="/dmca"> 
                                            DMCA Policy
                                        </Link> 
                                    </Text>

            
                                </Box>
                            </GridItem>
                            <GridItem colSpan={[2, 2, 2, 1]}>
                                <Box  mt={8}> 
                                    <Text fontSize="xl" color={"#4f8df7"} >
                                        Support
                                    </Text>
                                    <Text fontSize="sm"  mt={6}>
                                        <Link to="/contact">              
                                            Contact Us
                                        </Link>  
                                    </Text>
                                    <Text fontSize="sm"  mt={3}>
                                        <Link to="/guidelines"> 
                                            Community Guidelines
                                        </Link>  
                                    </Text>
                                    {/* <Text fontSize="sm"  mt={3}>
                                        <Link to="/process"> 
                                            FAQ
                                        </Link> 
                                    </Text> */}
           
            
                                </Box>
                            </GridItem>
                       
   

                
                        </Grid>
         
                    </Container>
                    <Box bg={"#4f8df7"} py={7}>
                        <Container maxW="80%" >
                            <Grid templateColumns={["repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(1, 1fr)", "repeat(2, 1fr)"]} gap={"0 1.5rem"} >
                                <Text color="white" fontSize="sm" fontWeight="900">
                                    © 2021 Proximy Technologies Inc. All rights reserved
                                </Text>
                                <Box/>
                                <Box/>
                                <Box>
                                    {/* <Grid templateColumns="repeat(3, 1fr)" color="white" float="right" gap={6}>
                                        <Text>
                                            hi
                                        </Text>
                                        <Text>
                                            hi
                                        </Text>
                                        <Text>
                                            hi
                                        </Text>
                                        
                                    </Grid> */}
                                </Box>


                            </Grid>
                        </Container>

                    </Box>
                </Box>
          
        </div>
    )
}